<!--
 * @Author: Gaho
 * @Date: 2023-12-14 13:34:24
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-30 16:32:48
 * @Description: 
-->

<template>
    <ModalTitle
        container-class=""
        :model-value="modelValue"
        :backdrop="backdrop"
        @update:model-value="onModelValue"
    >
        <template #header>
            <span class="text-[24px] leading-10">
                {{ `📑${$t('GameRules')}` }}
            </span>
        </template>
        <!-- 
            ↑ 顶部标题
            ↓ 窗口内容主体 
        -->
        <div class="w-full">
            <slot>
                
            </slot>
        </div>
        <template #footer >
            <ButtonThe3DButton
                color="red"
                size="lg"
                full-width
                @click="onModelValue(false)"
            >
                {{ $t('startPlaying') }}
            </ButtonThe3DButton>
        </template>
    </ModalTitle>
</template>

<script lang="ts" setup>
import useGlobalStore from '@/stores/global';

const oGlobalStore = useGlobalStore();

const props = defineProps({
    modelValue: Boolean, // 
    backdrop: {
        type: Boolean,
        default: true,
    },
});



const emit = defineEmits(['update:modelValue']);

// ↓监听窗口打开
watch(()=>props.modelValue, async (isShowing)=>{

});


const onModelValue = (value) => {
    // console.log('收到新值：', value); 
    emit('update:modelValue', !!value); 
};

</script>


<style lang="scss" scoped>


</style>


